export default "/_next/static/images/30/pictureDesktop-30e454c3951c337028bcffe7bc129ae2.png";